import React from 'react'
import Layout from '../components/remake/Layout'
import LoginComp from '../components/remake/LoginComp'

const LoginRemake = () => {
  return (
    <Layout>
        <LoginComp/>
    </Layout>
  )
}

export default LoginRemake